module.exports = __webpack_public_path__ + "static/media/research-8.cbb84c11.svg";